import {
  TOGGLE_CART_DRAWER,
  ADD_ITEM_TO_CART,
  REMOVE_ITEM_FROM_CART,
  UPDATE_ITEM_IN_CART,
  CLEAR_CART
} from '../constant/actionType';

export function toggleCartDrawer(open) {
  return async (dispatch, getState) => {
    if (open !== undefined || open !== null) {
      dispatch({ data: { open }, type: TOGGLE_CART_DRAWER });
      return;
    }

    const isOpen = getState().cart.isCartOpen;
    dispatch({ data: { open: !isOpen }, type: TOGGLE_CART_DRAWER });
  };
}

export function addItemToCart(name, tld, price, period) {
  return async (dispatch, getState) => {
    const { items } = getState().cart;
    const isInCart = items.filter((item) => item.title === name + tld);

    if (isInCart.length) {
      dispatch(toggleCartDrawer(true));
      return;
    }

    dispatch({
      data: {
        extra: [
          {
            enabled: true,
            id: '2',
            price: 5.0,
            subtitle:
              "Your contact info won't be available to the public. To help protect your info and prevent spam, a third party provides alternate contact info for your domain in the WHOIS directory at no extra cost. ",
            title: 'Privacy protection',
            type: 'checkbox'
          },
          {
            enabled: true,
            id: '3',
            price: 0,
            subtitle:
              'This domain will be auto-renewed around October 31 every year. You will automatically be billed when the renewal occurs.',
            title: 'Auto-renew',
            type: 'checkbox'
          }
        ],
        period: `${period} year`,
        price,
        title: `${name}${tld}`,
        type: 'domain'
      },
      type: ADD_ITEM_TO_CART
    });

    dispatch(toggleCartDrawer(true));
  };
}

export function removeItemFromCart(domain) {
  return async (dispatch) => {
    dispatch({
      data: {
        title: domain
      },
      type: REMOVE_ITEM_FROM_CART
    });
  };
}

export function updateItemInCart(title, body) {
  return async (dispatch) => {
    dispatch({
      data: {
        body,
        title
      },
      type: UPDATE_ITEM_IN_CART
    });
  };
}

export function clearCart() {
  return async (dispatch) => {
    dispatch({
      data: {},
      type: CLEAR_CART
    });

    dispatch(toggleCartDrawer(false));
  };
}
